/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/career-academy';

type Props = {
  jobTitles?: (string | null | undefined)[] | null;
};

const styles = {
  title: () => css`
    padding-bottom: var(--cds-spacing-150);
  `,
  jobTitleList: () => css`
    padding-inline-start: var(--cds-spacing-300);
  `,
};

const RoleDescriptionJobTitles = ({ jobTitles }: Props) => {
  if (!jobTitles?.length) {
    return null;
  }

  return (
    <div>
      <Typography variant="h2semibold" component="h3" css={styles.title}>
        {_t('Common job titles')}
      </Typography>
      <ul css={styles.jobTitleList}>
        {jobTitles.map((jobTitle) => (
          <li key={jobTitle}>
            <Typography2 component="p" variant="bodyPrimary">
              {jobTitle}
            </Typography2>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RoleDescriptionJobTitles;
